import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { FormElementGetService } from '../../services';

export const fetchFormElementGet = createAsyncThunk(
    'formElementGet/fetchFormElementGet',
    async ({ id }) => {
        const response = await FormElementGetService(id)
        return response.result
    }
);

const formElementGetSlice = createSlice({
    name: 'formElementGet',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchFormElementGet.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchFormElementGet.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchFormElementGet.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default formElementGetSlice.reducer;
